import { graphql, useStaticQuery } from 'gatsby';

const useSacredArchitecturesIndia = () => {
  const data = useStaticQuery(graphql`
    query {
      allMdx(
        # filter: { frontmatter: { series: { eq: "Sacred Architectures" } } }
        filter: { frontmatter: { country: { eq: "India" } } }
        sort: { fields: [frontmatter___name], order: ASC }
      ) {
        nodes {
          frontmatter {
            name
            slug
            title
            series
            media
            size
            year
            city
            state
            country
          }
        }
      }
    }
  `);

  return data.allMdx.nodes;
};

export default useSacredArchitecturesIndia;
